import { render, staticRenderFns } from "./sczjsj.vue?vue&type=template&id=338bf069&scoped=true&"
import script from "./sczjsj.vue?vue&type=script&lang=js&"
export * from "./sczjsj.vue?vue&type=script&lang=js&"
import style0 from "./sczjsj.vue?vue&type=style&index=0&id=338bf069&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338bf069",
  null
  
)

export default component.exports